<div class="container">
    <div class="row m-0">
        <div class="col p-0">
            <app-reports-filter [generateDisabled]="true"> </app-reports-filter>
        </div>
    </div>
    <!-- <div class="row mt-2">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'Reports.SelectReport' | translate }}</div>
        </div>
    </div> -->
</div>
